export function getStrapiUri(uri: string) {
	if (process.env.NODE_ENV === "production") {
		return process.env.REACT_APP_STRAPI_URL + uri;
	}

	return process.env.REACT_APP_STRAPI_DEV_URL + uri;
}
